"use client";

export const NAVIGATION_START_EVENT = "libum:navigation-start";

export function startNavigationFeedback() {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new Event(NAVIGATION_START_EVENT));
}
